<h2 mat-dialog-title class="audit-title">{{ dialogTitle }}</h2>

<mat-dialog-content class="audit-content">
    <div class="audit-filters">
        <mat-form-field appearance="outline">
            <mat-label>Type</mat-label>
            <mat-select [(value)]="actionFilter" (selectionChange)="loadHistory(true)">
                <mat-option value="">Tous</mat-option>
                <mat-option value="CREATE">Création</mat-option>
                <mat-option value="UPDATE">Modification</mat-option>
                <mat-option value="DELETE">Suppression</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Du</mat-label>
            <input matInput type="date" [(ngModel)]="dateFrom" (change)="loadHistory(true)">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Au</mat-label>
            <input matInput type="date" [(ngModel)]="dateTo" (change)="loadHistory(true)">
        </mat-form-field>

        <button mat-stroked-button class="audit-reset-button" type="button" (click)="clearFilters()">Réinitialiser</button>
    </div>

    @if (loading) {
        <div class="audit-state">
            <mat-spinner diameter="34"></mat-spinner>
        </div>
    }

    @if (!loading && errorMessage) {
        <div class="audit-state audit-error">{{ errorMessage }}</div>
    }

    @if (!loading && !errorMessage && events.length === 0) {
        <div class="audit-state">Aucun historique disponible.</div>
    }

    @if (!loading && !errorMessage && events.length > 0) {
        <div class="audit-events">
            @for (event of events; track trackByRevision($index, event)) {
                <article class="audit-event">
                    <header>
                        <div class="audit-event-title">
                            <span class="audit-badge" [class.create]="event.action === 'CREATE'" [class.delete]="event.action === 'DELETE'">
                                {{ actionLabel(event.action) }}
                            </span>
                            <span class="audit-label">{{ entityDisplayLabel(event) }}</span>
                        </div>
                        <div class="audit-meta">
                            <span>{{ event.timestamp | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                            <span>par {{ event.actor || 'system' }}</span>
                        </div>
                    </header>

                    @if (event.contextMessage) {
                        <p class="audit-context">{{ event.contextMessage }}</p>
                    }

                    @if (event.changes?.length) {
                        <ul>
                            @for (change of event.changes; track change.field) {
                                @if (shouldDisplayChange(change.field)) {
                                    <li>
                                        <strong>{{ fieldLabel(change.field) }}</strong>
                                        <span class="before">{{ formatValue(change.beforeValue) }}</span>
                                        <mat-icon svgIcon="heroicons_outline:arrow-right"></mat-icon>
                                        <span class="after">{{ formatValue(change.afterValue) }}</span>
                                    </li>
                                }
                            }
                        </ul>
                    }
                </article>
            }
        </div>
    }
</mat-dialog-content>

<mat-paginator
    [length]="totalElements"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)">
</mat-paginator>

<mat-dialog-actions align="end" class="audit-actions">
    <button mat-stroked-button class="audit-close-button" mat-dialog-close>Fermer</button>
</mat-dialog-actions>
